(function () {
  // Shared by every click handler below that reports on a link click: the publish()
  // chain is async (theme -> pixel sandbox -> gtag -> network), and a same-tab link
  // navigation can unload the page before it completes, silently dropping the event.
  // Holding navigation back briefly gives the beacon time to go out.
  function holdNavigationForBeacon(event, link) {
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href) return;

    const opensElsewhere =
      event.defaultPrevented ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0 ||
      link.target === '_blank';

    if (!opensElsewhere) {
      event.preventDefault();
      setTimeout(() => {
        window.location.href = href;
      }, 300);
    }
  }

  function publishGA4Event(eventName, data) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    window.Shopify.analytics.publish(`mmmi:${eventName}`, data || {});
  }

  function watchPopupOpen(el, onOpen) {
    if (!el || el.__ga4OpenObserverAttached) return;
    el.__ga4OpenObserverAttached = true;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const wasOpen = mutation.oldValue ? mutation.oldValue.includes('popup-open') : false;
        const isOpen = el.classList.contains('popup-open');
        if (isOpen && !wasOpen) onOpen(el);
      });
    });

    observer.observe(el, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }

  function attachSizeGuideTracking() {
    document.querySelectorAll('popup-wrapper[id^="size-guide"]').forEach((popup) => {
      watchPopupOpen(popup, () => {
        publishGA4Event('size_guide_opened', {
          product_id: popup.dataset.productId,
          product_title: popup.dataset.productTitle,
        });
      });
    });
  }

  function attachLocalizationTracking() {
    const popup = document.querySelector('localization-popup-wrapper');
    if (!popup) return;

    watchPopupOpen(popup, () => {
      publishGA4Event('localization_popup_opened', {
        current_country: popup.dataset.currentCountry,
      });
    });

    const form = popup.querySelector('#PopupCountryForm');
    const select = popup.querySelector('.localization-select');
    if (form && select && !form.__ga4SubmitTracked) {
      form.__ga4SubmitTracked = true;
      form.addEventListener('submit', (event) => {
        publishGA4Event('localization_market_selected', {
          from_country: popup.dataset.currentCountry,
          to_country: select.value,
        });

        // Same race as nav clicks: this form submit reloads the page, which can cut off
        // the publish chain before it reaches GA4. Hold it back briefly.
        if (!event.defaultPrevented) {
          event.preventDefault();
          setTimeout(() => form.submit(), 300);
        }
      });
    }
  }

  function attachKlaviyoTracking() {
    if (window.__ga4KlaviyoTracked) return;
    window.__ga4KlaviyoTracked = true;

 
    // window.addEventListener('klaviyoForms', (event) => {
    //   const { type, formId } = event.detail || {};
    //   if (type === 'open') {
    //     publishGA4Event('klaviyo_teaser_opened', { form_id: formId });
    //   }
    // });

    document.addEventListener('click', (event) => {
      const teaser = event.target.closest('[class*="kl-teaser-"]');
      if (!teaser) return;
      if (event.target.closest('.klaviyo-close-form')) return;
      if (!event.target.closest('[role="button"]')) return;

      const teaserClass = Array.from(teaser.classList).find((cls) => cls.startsWith('kl-teaser-'));
      const formId = teaserClass ? teaserClass.slice('kl-teaser-'.length) : undefined;

      publishGA4Event('klaviyo_teaser_clicked', { form_id: formId });
    });
  }

  function attachPromotionTracking() {
    if (!window.__ga4PromotionObserver) {
      window.__ga4PromotionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.target.__ga4ViewFired) return;
            entry.target.__ga4ViewFired = true;
            const { promotionId, promotionName, creativeSlot, locationId } = entry.target.dataset;
            publishGA4Event('view_promotion', {
              promotion_id: promotionId,
              promotion_name: promotionName,
              creative_slot: creativeSlot,
              location_id: locationId,
            });
          });
        },
        { threshold: 0.5 }
      );
    }

    document.querySelectorAll('[data-promotion-id]').forEach((el) => {
      if (el.__ga4PromotionAttached) return;
      el.__ga4PromotionAttached = true;
      window.__ga4PromotionObserver.observe(el);
    });

    if (!window.__ga4PromotionClickTracked) {
      window.__ga4PromotionClickTracked = true;
      document.addEventListener('click', (event) => {
        const promo = event.target.closest('[data-promotion-id]');
        if (!promo) return;
        const { promotionId, promotionName, creativeSlot, locationId } = promo.dataset;
        publishGA4Event('select_promotion', {
          promotion_id: promotionId,
          promotion_name: promotionName,
          creative_slot: creativeSlot,
          location_id: locationId,
        });
        holdNavigationForBeacon(event, event.target.closest('a'));
      });
    }
  }

  function attachNavMenuTracking() {
    if (window.__ga4NavMenuTracked) return;
    window.__ga4NavMenuTracked = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest(
        '.header .header__menu-item, .header .mega-menu__link, .header .list-menu__item--link, .header .menu-drawer__menu-item'
      );
      if (!link) return;

      // These classes are reused by non-nav rows too (e.g. the currency/market display
      // inside the drawer menu, which carries .menu-drawer__menu-item but has no real
      // href) -- only count it as a nav click if it's an actual link going somewhere.
      const navHref = link.getAttribute('href');
      if (!navHref || navHref === '#') return;

      let menuLevel = 'top';
      if (link.classList.contains('mega-menu__link--level-2')) menuLevel = 'level-2';
      else if (link.classList.contains('mega-menu__link')) menuLevel = 'level-3';

      publishGA4Event('nav_menu_click', {
        link_text: link.textContent.trim(),
        link_url: link.getAttribute('href') || '',
        menu_level: menuLevel,
      });

      holdNavigationForBeacon(event, link);
    });
  }

  function attachFacetsTracking() {
    if (window.__ga4FacetsTracked) return;
    window.__ga4FacetsTracked = true;

    document.addEventListener('change', (event) => {
      const form = event.target.closest('facet-filters-form');
      if (!form) return;

      const input = event.target;
      if (input.id === 'SortBy') {
        publishGA4Event('collection_sort_applied', {
          sort_value: input.value,
          collection_path: window.location.pathname,
        });
      } else if (input.matches('input[type="checkbox"], input[type="radio"], input[type="range"]')) {
        publishGA4Event('collection_filter_applied', {
          filter_name: input.name,
          filter_value: input.value,
          applied: input.type === 'radio' ? true : input.checked,
          collection_path: window.location.pathname,
        });
      }
    });

    // The live sort UI (filter_type != 'vertical') is button-based, not a <select>:
    // snippets/facets.liquid comments out the real <select id="SortBy"> and renders
    // #SortButtons .facet-filters__sort-btn instead, which just sets a hidden input's
    // value via JS -- that never fires a "change" event, so the listener above alone
    // never caught it.
    document.addEventListener('click', (event) => {
      const sortBtn = event.target.closest('.facet-filters__sort-btn');
      if (!sortBtn) return;

      publishGA4Event('collection_sort_applied', {
        sort_value: sortBtn.dataset.sort,
        collection_path: window.location.pathname,
      });
    });
  }

  function attachLoadMoreTracking() {
    if (window.__ga4LoadMoreTracked) return;
    window.__ga4LoadMoreTracked = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('#load-more');
      if (!button) return;

      const countEl = button.closest('load-more-grid')?.querySelector('.load-more-current-count');

      publishGA4Event('collection_load_more_clicked', {
        collection_path: window.location.pathname,
        products_shown_before: countEl ? Number(countEl.textContent) : undefined,
        products_total: Number(button.dataset.pageItems) || undefined,
      });
    });
  }

  // Several [data-item-list-id] containers (PDP "You may also like", mini-cart
  // recommend) render empty on page load and only get their items[] filled in later via
  // Dawn's own lazy-fetch (assets/global.js ProductRecommendations sets .innerHTML once
  // its AJAX call to /recommendations/products resolves). That fetch is gated by its own
  // separate IntersectionObserver, racing against ours -- if ours fires first, items.length
  // is 0 and we must NOT mark __ga4ViewFired yet, or the real content arriving moments
  // later would never get reported.
  function attachItemListTracking() {
    if (!window.__ga4ItemListObserver) {
      window.__ga4ItemListObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.target.__ga4ViewFired) return;

            const items = readGA4Items(entry.target);
            if (!items.length) return; // stay unmarked -- content may still be loading

            entry.target.__ga4ViewFired = true;
            const viewEvent = entry.target.dataset.gaViewEvent;
            if (!viewEvent) return;
            publishGA4Event(viewEvent, {
              item_list_id: entry.target.dataset.itemListId,
              item_list_name: entry.target.dataset.itemListName,
              items,
            });
          });
        },
        { threshold: 0.25 }
      );
    }

    document.querySelectorAll('[data-item-list-id]').forEach((el) => {
      if (el.__ga4ItemListAttached) return;
      el.__ga4ItemListAttached = true;
      window.__ga4ItemListObserver.observe(el);
      watchForLateItems(el);
    });

    if (!window.__ga4ItemListClickTracked) {
      window.__ga4ItemListClickTracked = true;
      document.addEventListener('click', (event) => {
        const itemEl = event.target.closest('[data-item-id]');
        const listEl = itemEl && itemEl.closest('[data-item-list-id]');
        if (!itemEl || !listEl) return;

        const selectEvent = listEl.dataset.gaSelectEvent;
        if (!selectEvent) return;

        const items = readGA4Items(listEl);
        const item = items.find((candidate) => String(candidate.item_id) === itemEl.dataset.itemId);
        if (!item) return;

        publishGA4Event(selectEvent, {
          item_list_id: listEl.dataset.itemListId,
          item_list_name: listEl.dataset.itemListName,
          items: [item],
        });
        holdNavigationForBeacon(event, event.target.closest('a'));
      });
    }
  }

  function readGA4Items(listEl) {
    if (listEl.__ga4Items) return listEl.__ga4Items;
    const script = listEl.querySelector('script[data-ga4-items]');
    if (!script) return [];
    try {
      listEl.__ga4Items = JSON.parse(script.textContent);
    } catch (error) {
      listEl.__ga4Items = [];
    }
    return listEl.__ga4Items;
  }

  // Covers the Dawn lazy-fetch race described above: once real content (and our
  // <script data-ga4-items>) shows up later via .innerHTML replacement, drop the stale
  // empty-array cache and force the view observer to re-check this element right now
  // (unobserve+observe reports the element's current intersection state immediately).
  function watchForLateItems(el) {
    if (el.__ga4ContentObserver) return;
    el.__ga4ContentObserver = new MutationObserver(() => {
      if (el.__ga4ViewFired) {
        el.__ga4ContentObserver.disconnect();
        return;
      }
      delete el.__ga4Items;
      if (!readGA4Items(el).length) return;

      window.__ga4ItemListObserver.unobserve(el);
      window.__ga4ItemListObserver.observe(el);
      el.__ga4ContentObserver.disconnect();
    });
    el.__ga4ContentObserver.observe(el, { childList: true, subtree: true });
  }

  // "Colour way" isn't a variant option here -- each colour is a SEPARATE product
  // (snippets/product-swatch.liquid), so clicking a swatch is a real <a href> navigation
  // to a sibling product, not a Shopify variant change. PUB_SUB_EVENTS.variantChange
  // never fires for this, which is why colour_way_clicked never showed up in GA4.
  function attachColourWayTracking() {
    if (!window.__ga4ColourWayObserver) {
      window.__ga4ColourWayObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.target.__ga4ViewFired) return;
            entry.target.__ga4ViewFired = true;

            const swatches = Array.from(entry.target.querySelectorAll('.swatch-element-product'));
            const current = entry.target.querySelector('.swatch-element-active');

            publishGA4Event('colour_way_viewed', {
              current_colour: current?.dataset.value,
              colour_count: swatches.length,
              available_colours: swatches.map((el) => el.dataset.value).filter(Boolean).join(','),
            });
          });
        },
        { threshold: 0.5 }
      );
    }

    document.querySelectorAll('.thumbnail-swatch').forEach((el) => {
      if (el.__ga4ColourWayAttached) return;
      el.__ga4ColourWayAttached = true;
      window.__ga4ColourWayObserver.observe(el);
    });

    if (window.__ga4ColourWayClickTracked) return;
    window.__ga4ColourWayClickTracked = true;

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('.thumbnail-swatch .swatch-element-product');
      const link = swatch && swatch.closest('a[href]');
      if (!swatch || !link) return;

      publishGA4Event('colour_way_clicked', {
        colour: swatch.dataset.value,
        destination_url: link.getAttribute('href'),
      });

      holdNavigationForBeacon(event, link);
    });
  }

  function attachCartRefreshResubscribe() {
    if (window.__ga4CartRefreshTracked) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window.__ga4CartRefreshTracked = true;

    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      attachItemListTracking();
    });
  }

  function attachCartErrorTracking() {
    if (window.__ga4CartErrorTracked) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartError) return;
    window.__ga4CartErrorTracked = true;

    subscribe(PUB_SUB_EVENTS.cartError, (event) => {
      publishGA4Event('add_to_cart_error', {
        source: event.source,
        variant_id: event.productVariantId,
        errors: event.errors,
        message: event.message,
      });
    });
  }

  function attachMinicartTracking() {
    if (window.__ga4MinicartTracked) return;
    window.__ga4MinicartTracked = true;

    document.body.addEventListener('cart-drawer:open', () => {
      // cart-drawer.js replaces the drawer's innerHTML (including the "You might also
      // like" block) BEFORE dispatching this event -- unlike PUB_SUB_EVENTS.cartUpdate,
      // which this script subscribes to earlier than cart-drawer.js does (load order
      // in theme.liquid), so it fires before that HTML swap happens. Re-scanning here
      // instead is what actually catches the newly-inserted recommend block.
      attachItemListTracking();

      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';

      fetch(`${cartUrl}.js`)
        .then((response) => response.json())
        .then((cart) => {
          publishGA4Event('minicart_opened', {
            currency: cart.currency,
            value: cart.total_price / 100,
            items: cart.items.map((item, index) => ({
              item_id: item.product_id,
              item_name: item.product_title,
              item_variant: item.variant_title,
              price: item.price / 100,
              quantity: item.quantity,
              index,
            })),
          });
        })
        .catch(() => {
          publishGA4Event('minicart_opened', {});
        });
    });
  }

  function attachCartIconTracking() {
    if (window.__ga4CartIconTracked) return;
    window.__ga4CartIconTracked = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('#cart-icon-bubble');
      if (!link) return;

      publishGA4Event('cart_icon_clicked', {
        cart_count: link.querySelector('[data-cart-count]')?.textContent?.trim(),
      });

      // On cart_type: drawer, cart-drawer.js already preventDefault()s this same click
      // (bound directly on the link, so it runs before this bubbles here) and opens the
      // drawer instead -- in that case event.defaultPrevented is already true and
      // holdNavigationForBeacon leaves navigation alone. On cart_type: page there's no
      // such handler, this is a real link to /cart, so it gets the same unload race as
      // nav_menu_click.
      holdNavigationForBeacon(event, link);
    });
  }

  function attachCookieConsentTracking() {
    if (window.__ga4ConsentTracked) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.__ga4ConsentTracked = true;

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) return;

      document.addEventListener('visitorConsentCollected', (event) => {
        // event.detail is flat, with an "Allowed" suffix per Shopify's docs -- not
        // { analytics, marketing, ... } and not nested under .customerPrivacy. That
        // mismatch meant every field read as undefined, so this always published false.
        const consent = event.detail || {};
        const { analyticsAllowed, marketingAllowed, preferencesAllowed, saleOfDataAllowed } = consent;

        let choice = 'custom';
        if (analyticsAllowed && marketingAllowed && preferencesAllowed) choice = 'accept_all';
        else if (!analyticsAllowed && !marketingAllowed && !preferencesAllowed) choice = 'reject_all';

        publishGA4Event('cookie_consent_choice', {
          choice,
          analytics: !!analyticsAllowed,
          marketing: !!marketingAllowed,
          preferences: !!preferencesAllowed,
          sale_of_data: !!saleOfDataAllowed,
        });
      });
    });
  }

  function attachAll() {
    attachSizeGuideTracking();
    attachLocalizationTracking();
    attachKlaviyoTracking();
    attachPromotionTracking();
    attachNavMenuTracking();
    attachFacetsTracking();
    attachLoadMoreTracking();
    attachItemListTracking();
    attachColourWayTracking();
    attachCartRefreshResubscribe();
    attachCartErrorTracking();
    attachMinicartTracking();
    attachCartIconTracking();
    attachCookieConsentTracking();
  }

  document.addEventListener('DOMContentLoaded', attachAll);
  document.addEventListener('shopify:section:load', attachAll);
})();
